import { render } from "./IndexPengadaan.vue?vue&type=template&id=119e37c4"
import script from "./IndexPengadaan.vue?vue&type=script&lang=js"
export * from "./IndexPengadaan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__